import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0b002d47"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "PaintingTutorial view-default z-painting-tutorial" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "Backdrop" }, null, -1))
const _hoisted_3 = { class: "Modal view-default__inner" }
const _hoisted_4 = { class: "Modal__Background rounded-24 bg-gradient" }
const _hoisted_5 = { class: "Modal__Inner" }
const _hoisted_6 = { class: "Step__Animation" }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = { class: "Nav small-caps" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  fill: "none",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "12",
    cy: "12",
    r: "11",
    stroke: "url(#PaintingTutorial-NavBtn-gradient)",
    "stroke-width": "2"
  })
], -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  style: {"width":"0","height":"0","position":"absolute"},
  "aria-hidden": "true",
  focusable: "false"
}, [
  /*#__PURE__*/_createElementVNode("linearGradient", {
    id: "PaintingTutorial-NavBtn-gradient",
    x1: "3.91",
    x2: "28.02",
    y1: "-7.06",
    y2: "2.6",
    gradientUnits: "userSpaceOnUse"
  }, [
    /*#__PURE__*/_createElementVNode("stop", { "stop-color": "#F5AAE0" }),
    /*#__PURE__*/_createElementVNode("stop", {
      offset: ".48",
      "stop-color": "#A47CDA",
      "stop-opacity": ".82"
    }),
    /*#__PURE__*/_createElementVNode("stop", {
      offset: "1",
      "stop-color": "#4D4BD2",
      "stop-opacity": ".63"
    })
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inset_border = _resolveComponent("inset-border")!
  const _component_heading = _resolveComponent("heading")!
  const _component_ui_btn = _resolveComponent("ui-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_inset_border)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          (_openBlock(), _createElementBlock("div", {
            ref: "lottieContainer",
            key: _ctx.currentStep.index
          }, null, 512))
        ]),
        _createVNode(_component_heading, { class: "Step__Title" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$rt(_ctx.currentStep.title)), 1)
          ]),
          _: 1
        }),
        _createElementVNode("div", {
          class: "Step__Description text",
          innerHTML: _ctx.$rt(_ctx.currentStep.description)
        }, null, 8, _hoisted_7),
        _createVNode(_component_ui_btn, { onClick: _ctx.gotoNextStep }, {
          default: _withCtx(() => [
            _createElementVNode("span", { innerHTML: _ctx.ctaNext }, null, 8, _hoisted_8)
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createElementVNode("button", {
          type: "button",
          class: "Link small-caps",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onSkip && _ctx.onSkip(...args)))
        }, _toDisplayString(_ctx.$t('painting_tutorial.cta_skip')), 1),
        _createElementVNode("ul", _hoisted_9, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.nbSteps, (n, index) => {
            return (_openBlock(), _createElementBlock("li", {
              key: n,
              class: "Nav__Item"
            }, [
              _createElementVNode("button", {
                type: "button",
                class: _normalizeClass(["Nav__Btn", { 'is-active': index === _ctx.currentStep.index }]),
                onClick: ($event: any) => (_ctx.gotoStep(index))
              }, [
                _createTextVNode(_toDisplayString(n) + " ", 1),
                _hoisted_11
              ], 10, _hoisted_10)
            ]))
          }), 128))
        ]),
        _hoisted_12
      ])
    ])
  ]))
}